function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPrioritysignArrowNa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prioritysign_x5F_arrow_x5F_na",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF0000"
    },
    cx: 14,
    cy: 10,
    r: 5.5
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00CC00"
    },
    points: "32,4.001 32,6.829 34.171,9 26,9 26,11 34.172,11 32,13.172 32,16.001 38,10.001 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M14,5c2.761,0,5,2.239,5,5s-2.239,5-5,5s-5-2.239-5-5S11.239,5,14,5 M14,4c-3.308,0-6,2.692-6,6 s2.692,6,6,6s6-2.692,6-6S17.308,4,14,4L14,4z M14,19c2.761,0,5,2.239,5,5s-2.239,5-5,5s-5-2.239-5-5S11.239,19,14,19 M14,18 c-3.308,0-6,2.692-6,6s2.692,6,6,6s6-2.692,6-6S17.308,18,14,18L14,18z M14,33c2.761,0,5,2.239,5,5s-2.239,5-5,5s-5-2.239-5-5 S11.239,33,14,33 M14,32c-3.308,0-6,2.692-6,6s2.692,6,6,6s6-2.692,6-6S17.308,32,14,32L14,32z M38.707,9.294l-6-6L31,1.586v2.414 v2.828v0.414l0.293,0.293L31.757,8H26h-1v1v2v1h1h5.758l-0.465,0.465L31,12.758v0.414v2.828v2.414l1.707-1.707l6-6l0.707-0.707 L38.707,9.294z M32,16.001v-2.828L34.172,11H26V9h8.171L32,6.829V4.001l6,6L32,16.001z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrioritysignArrowNa);
export default __webpack_public_path__ + "static/media/icon-prioritysign_arrow_na.9c2b144fba435f7d914684d7b30c966c.svg";
export { ForwardRef as ReactComponent };